/*
 * Adapted from
 * typeahead.js
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
 */

function toStr(s) {
  return (typeof s === 'undefined' || s === null) ? '' : s + '';
}

function whitespace(str) {
  str = toStr(str);
  return str ? str.split(/\s+/) : [];
}

function nonword(str) {
  str = toStr(str);
  return str ? str.split(/\W+/) : [];
}

function getObjTokenizer(tokenizer) {
  return function setKey(keys) {
    keys = Array.isArray(keys) ? keys : [].slice.call(arguments, 0);

    return function tokenize(o) {
      let tokens = [];

      keys.forEach((k) => {
        tokens = tokens.concat(tokenizer(toStr(o[k])));
      });

      return tokens;
    };
  };
}

const Tokenizers = {
  nonword: nonword,
  whitespace: whitespace,
  obj: {
    nonword: getObjTokenizer(nonword),
    whitespace: getObjTokenizer(whitespace)
  }
};

export default Tokenizers;
